var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-row",
    { attrs: { gutter: 20 } },
    _vm._l(_vm.wallets, function (wallet) {
      return _c(
        "el-col",
        { key: wallet.name, attrs: { span: 12 } },
        [
          _c("el-statistic", {
            staticClass: "card-panel",
            attrs: {
              "group-separator": ",",
              precision: 2,
              value: wallet.amount,
              title: wallet.text,
            },
          }),
        ],
        1
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }